import React, { FC } from 'react'

import { ExtraServiceReservation } from '../../../common/validations/extraServiceReservationSchema'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'
import { useAPIGetExtraServiceReservationsSuspense } from 'api/apiHooks/useAPIGetExtraServiceReservations'

export const ExtraServiceReservationsDataLoader: FC<{
  type: 'storage' | 'right_of_access'
  children: (reservations: ExtraServiceReservation[]) => React.ReactNode
}> = ({ type, children }) => {
  const { currentContractId } = useCurrentContract()
  const { data } = useAPIGetExtraServiceReservationsSuspense(currentContractId)

  const filteredReservations =
    data?.extraServiceReservations.filter((r) => r.type === type) ?? []

  return <>{children(filteredReservations)}</>
}
